import type { Route } from './+types/home';

export function meta(_: Route.MetaArgs) {
  return [
    { title: 'Tekavra Styling Room' },
    {
      name: 'description',
      content:
        "Find your real interior design style — a 15-question quiz that scores every style at once and blends the result, instead of forcing you into one label.",
    },
  ];
}

export default function Home() {
  return (
    <main className="container">
      <p className="eyebrow">Tekavra Styling Room</p>
      <h1 style={{ fontSize: 'clamp(2.2rem, 6vw, 3.6rem)', marginTop: 12, marginBottom: 16, maxWidth: '18ch' }}>
        Find your real style — blended, not boxed in.
      </h1>
      <p className="muted" style={{ maxWidth: '52ch', marginBottom: 28, fontSize: '1.1rem' }}>
        Fifteen questions. No forced label, no paywalled result. Just your actual taste, scored
        honestly, with a room generated to match.
      </p>
      <a href="/quiz" className="ui-btn btn-primary btn-lg">
        Take the quiz
      </a>
    </main>
  );
}
